
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/checkout/contact",
      function () {
        return require("private-next-pages/shop/checkout/contact.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/checkout/contact"])
      });
    }
  